import { useEffect, useState } from "react";
import { formatCountdown, renderTypeMapEnums } from "./utils";
import { useGoodsFocus } from "../tab-goods-content/GoodsFocusContext";
import { GoodsItem, GoodsGroup } from "../../types";
import { useUserContext } from "../../routes/home/userContext";
// 各组件的样式已在其各自文件中导入

const GeneralGoodsItem = ({
  goodItem, // 商品信息
  index,
  showTriangle = true,
  doBuyMemberGoods,
  type = "SMALL_GOODS",
}: {
  goodItem: GoodsItem;
  index: number;
  showTriangle?: boolean;
  doBuyMemberGoods?: (goodItem: GoodsItem) => void;
  type?: keyof typeof renderTypeMapEnums;
}) => {
  const { focusedGoods, setFocusedGoods, currentGroups, countNum } =
    useGoodsFocus();
    const { levelInfo, balanceCredit } = useUserContext();
  const [countdown, setCountdown] = useState("");

  const isSeckill = goodItem?.discountType === "SECONDS_KILL_PRICE";
  const isDiscount =
    goodItem?.discountType !== "ORIGINAL_PRICE" &&
    goodItem?.salePrice !== goodItem?.discountBuyPrice;

    const isCarOwner = levelInfo?.memberType === 1;
    const showCreditPrice = isCarOwner || (!isCarOwner && balanceCredit > 0)

  useEffect(() => {
    if (goodItem?.secondsKillEndLastMillis && countNum !== null) {
      const timeLeft = goodItem?.secondsKillEndLastMillis - countNum * 1000;
      if (timeLeft <= 0) {
        setCountdown("00:00:00");
      } else {
        setCountdown(formatCountdown(timeLeft));
      }
    }
  }, [countNum, goodItem?.secondsKillEndLastMillis]);

  if (!goodItem) return null;

  const RenderComponent = renderTypeMapEnums[type] as React.ComponentType<{
    goodItem: GoodsItem;
    index: number;
    showTriangle: boolean;
    active: GoodsItem | null;
    activeChange: (active: GoodsItem | null) => void;
    doBuyMemberGoods?: (goodItem: GoodsItem) => void;
    type: keyof typeof renderTypeMapEnums;
    isSeckill: boolean;
    countdown: string;
    currentGroups: GoodsGroup[];
    isDiscount: boolean;
    showCreditPrice: boolean;
  }>;
  return (
    <RenderComponent
      goodItem={goodItem}
      index={index}
      showTriangle={showTriangle}
      active={focusedGoods}
      activeChange={setFocusedGoods}
      doBuyMemberGoods={doBuyMemberGoods}
      type={type}
      isSeckill={isSeckill}
      countdown={countdown}
      currentGroups={currentGroups}
      isDiscount={isDiscount}
      showCreditPrice={showCreditPrice}
    />
  );
};
export default GeneralGoodsItem;
